import {FIELDS} from "../../fields3/fields.const"
import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {FieldType} from "../../fields3/field-type"
import {timezoneOptions} from "../../gd/utils/datetime/timezone-options"

export default class CrmContactFieldsHelper {

    static getFieldsConfig() {
        // add system fields
        const systemFields = CrmContactFieldsHelper.getSystemFieldsConfig();
        const customFields = CrmContactFieldsHelper.getCustomFieldsConfig();

        return [...systemFields, ...customFields];
    }

    static getSystemFieldsConfig() {

        const companyUsers = gd.session.companyUsers.filterByCompany(gd.companyId).map((cu: any)=>({
            value: cu.user.id,
            label: cu.user.name
        }));

        return [
            {fieldId: 'firstName',          label: 'First Name',        type: FIELDS.STRING,            defaultWidth: 200,  isRequired: true},
            {fieldId: 'lastName',           label: 'Last Name',         type: FIELDS.STRING,            defaultWidth: 200},
            {fieldId: 'crmAccountId',       label: 'Company',           type: FIELDS.CRM_ACCOUNT,       defaultWidth: 200},
            {fieldId: 'contactType',        label: 'Contact type',      type: FIELDS.CRM_CONTACT_TYPE,  defaultWidth: 150},
            {fieldId: 'contactOwnerUserId', label: 'Contact owner',     type: FIELDS.USER,              defaultWidth: 150,  options: companyUsers},
            {fieldId: 'phone',              label: 'Phone',             type: FIELDS.PHONE,             defaultWidth: 150,  placeholder: "Add phone"},
            {fieldId: 'email',              label: 'Email',             type: FIELDS.EMAIL,             defaultWidth: 200,  placeholder: "Add email"},
            // {fieldId: 'timezone',           label: 'Timezone',          type: FIELDS.DROPDOWN,          defaultWidth: 200,  options: timezoneOptions(), showMenuMore: false},
            {fieldId: 'name',               label: 'Name',              type: FIELDS.STRING,            defaultWidth: 275,  isDerived: true},
            {fieldId: 'notes',              label: 'Notes',             type: FIELDS.TEXT,              defaultWidth: 140,  placeholder: "Add a note..."},
        ];
    }

    static getCustomFieldsConfig() {
        const company = gd.session.companies.get(gd.companyId)
        const fields = company.settings.modules.crmContact.customFields || []
        _.map(fields, field=>{
            field.isCustom = true

            // patch for previously saved users options (there should be none to always show actual company users options)
            switch (field.type) {
                case FieldType.USERS:
                case FieldType.USER:
                    field.options = []
                    break
            }
        })
        return fields;
    }


    static saveCustomFields(fieldsCollection: FieldsCollection) {

        const customFields = fieldsCollection.customFields()
        const config = _.map(customFields, field=>{
            switch (field.type) {
                // do not save users options
                case FieldType.USERS:
                case FieldType.USER:
                    field.options = []
                    break
            }

            return field.toJson()
        })

        const company = gd.session.companies.get(gd.companyId)
        company.settings.modules.crmContact.customFields = config
        company.settings.save()
    }
}
